import styled, { css } from 'styled-components';

import CSearchBox from '@/components/SearchBox';

export const Wrapper = styled.div``;

export const SearchBox = styled(CSearchBox)`
  margin-bottom: 7.5rem;
`;

export const EventsWrapper = styled.section`
  margin-bottom: 6rem;
`;

export const EventsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  grid-column-gap: 1.7rem;
  grid-row-gap: 3.6rem;
  justify-items: center;

  article a > img {
    /* height: 17rem; */
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const LoadMoreWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  margin-bottom: 6rem;
`;

export const LoadMoreButton = styled.button`
  ${({ theme }) => css`
    color: ${theme.color.white};
    background: ${theme.color.primary};
    padding: 1.2rem 6.3rem;
    text-transform: uppercase;
    font-weight: ${theme.font.weight.medium};
    font-size: 1.4rem;
    border-radius: 0.5rem;
  `}
`;
